// extracted by mini-css-extract-plugin
module.exports = {"bg":"Kilian-styles-module--bg--3acd6","image":"Kilian-styles-module--image--1w-oV","cta":"Kilian-styles-module--cta--_f3db"};